import React, { Component } from 'react';
import { Tabs, Modal, message} from 'antd';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import logo from './imgs/logo.svg';
import './PartnerList.css';

const TabPane = Tabs.TabPane;
class PartnerList extends Component {

  state = {
    username: '',
    offerData: {},
    visible: false,
  };

  componentWillMount() {
    this.setState({
        username: this.props.username,
    })
  }

  // componentWillReceiveProps(thisProps) {
  //   this.setState({
  //     username: thisProps.username,
  //   })
  // }

  handleClick(item) {
    if (this.state.username === null || this.state.username.length !== 40) {
      message.error('Please login to active your cashback.');
    }
    this.setState({
      offerData: {
        storeUrl: item.storeUrl,
        logoUrl: item.logoUrl,
        offerRate: item.offerRate,
        offerDetails: item.offerDetails,
      },
      visible: true,
    });
  }

  handleOk = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleOpen = () => {
    this.handleCancel();
    window.open(this.state.offerData.storeUrl);
  };

  render() {
    const arr = [];
    let newArr = [];
    if (this.props.data !== undefined) {
      for (let i in this.props.data) {
        arr.push({ [i]: this.props.data[i] });
      }

      arr.sort((a, b) => {
        return Object.keys(a)[0] > Object.keys(b)[0] ? 1 : -1;
      });

      const first = arr.shift();

      const tempArr = _.chunk(arr, 5);

      newArr = tempArr.map(data => {
        const temp = data.map(data => {
          return Object.values(data)[0];
        });
        return {[`${Object.keys(data[0])[0]} - ${Object.keys(data[data.length - 1])[0]}`]: _.flatten(temp)}
      });

      newArr.unshift(first);
    }

    return (
      <div className='PartnerList'>
        <div className='Tabs'>
          <Tabs defaultActiveKey="0">
            {newArr.length !== 0 && newArr.map((item, i) => {
              return (
                <TabPane tab={Object.keys(item)[0]} key={i} className='TabPane'>
                  {Object.values(item)[0].map((data, i) => {
                    return (
                      <div key={i} className='Partner' onClick={() => this.handleClick(data)}>
                        <img src={data.logoUrl} alt={data.storeName}/>
                        <p>{data.storeName}</p>
                      </div>
                    )
                  })}
                </TabPane>
              )
            })}
          </Tabs>
        </div>
        <Modal
          onOk={this.handleOk}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          wrapClassName="vertical-center-modal"
          className='storesModal'
        >
          <div className="modal-header">
            <img src={this.state.offerData.logoUrl} alt='logo' className='logo'/>
            <div>
              <img src={logo} alt="qbates"/>
              <h3>Cashback up to {this.state.offerData.offerRate}</h3>
            </div>
          </div>
          <div className="modal-body">
            {this.state.offerData.offerDetails !== undefined && this.state.offerData.offerDetails.map((data, index) => {
              return (
                <div key={index} className='listItem'>
                  <span className='goods'>{data.split(':')[0]}</span>
                  <span className='rate'>{data.split(':')[1]} cashback</span>
                </div>
              )
            })}
          </div>
          <div className='button'>
            <button onClick={() => {this.state.username !== '' && this.state.username !== null ? this.handleOpen() : this.props.history.push('/login')}}>Activate Cashback up to {this.state.offerData.offerRate}</button>
            <button id="mobile" onClick={() => {this.state.username !== '' && this.state.username !== null ? this.handleOpen() : this.props.history.push('/login')}}>Activate Now!</button>
          </div>
        </Modal>
      </div>
    )
  }
}

export default withRouter(PartnerList);


// WEBPACK FOOTER //
// ./src/Containers/Stores/components/PartnerList.js